export default [
	{
		path: '/insumos',
		name: 'fuels.index',
		component: () => import(/* webpackChunkName: "fuels.index" */ './pages/Index.vue')
	}
]